import { render } from "./Sub.vue?vue&type=template&id=39909c76"
import script from "./Sub.vue?vue&type=script&lang=js"
export * from "./Sub.vue?vue&type=script&lang=js"

import "./Sub.vue?vue&type=style&index=0&id=39909c76&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__